import AdminHttpClient from './AdminHttpService';

function getToken() {
    return localStorage.getItem('admin_token');
}

function isAuthenticated() {
    return !!getToken();
}

function saveToken(token) {
    localStorage.setItem('admin_token', token);
}

function logout() {
    localStorage.removeItem('admin_token');
}

function init(email) {
    return AdminHttpClient.post('/auth/init', { email });
}

function setup(email, totp_code) {
    return AdminHttpClient.post('/auth/setup', { email, totp_code });
}

function login(email, totp_code) {
    return AdminHttpClient.post('/auth/login', { email, totp_code });
}

export default { getToken, isAuthenticated, saveToken, logout, init, setup, login };
